export default __webpack_public_path__ + "static/media/app_store.ff2f2ad2.png";